<template>
  <div class="download-container">
    <div class="download-content">
      <div class="content-wrapper">
        <div class="header-section">
          <h1 class="page-title">下载建企悦APP</h1>
        </div>
        
        <div class="app-section">
          <el-row :gutter="40" type="flex" align="middle" class="app-row">
            <el-col :span="12" class="app-info-col">
              <div class="app-info">
                <h2 class="app-title">建企悦APP</h2>
                <p class="app-description">专为建筑行业打造的一站式服务平台</p>
                <ul class="features-list">
                  <li class="feature-item">
                    <i class="el-icon-check feature-icon"></i>
                    <span class="feature-text">实时获取招标信息</span>
                  </li>
                  <li class="feature-item">
                    <i class="el-icon-check feature-icon"></i>
                    <span class="feature-text">企业资质查询</span>
                  </li>
                  <li class="feature-item">
                    <i class="el-icon-check feature-icon"></i>
                    <span class="feature-text">在线加盟合作</span>
                  </li>
                  <li class="feature-item">
                    <i class="el-icon-check feature-icon"></i>
                    <span class="feature-text">行业资讯推送</span>
                  </li>
                  <li class="feature-item">
                    <i class="el-icon-check feature-icon"></i>
                    <span class="feature-text">更多实用功能持续更新</span>
                  </li>
                </ul>
                <!-- <p class="download-note">扫描下方二维码或点击按钮下载</p> -->
              </div>
            </el-col>
            <el-col :span="12" class="qr-col">
              <div class="qr-section">
                <div class="qr-code">
                  <img src="../assets/img/jqy-app.jpeg" alt="APP下载二维码" class="qr-image" />
                  <p class="qr-text">扫码下载APP</p>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
        
        <!-- <div class="download-buttons-section">
          <div class="buttons-container">
            <el-button type="primary" size="large" @click="downloadForiOS" class="download-btn ios-btn">
              <i class="el-icon-platform-eleme btn-icon"></i>
              <span class="btn-text">iPhone版下载</span>
            </el-button>
            <el-button type="success" size="large" @click="downloadForAndroid" class="download-btn android-btn">
              <i class="el-icon-mobile-phone btn-icon"></i>
              <span class="btn-text">Android版下载</span>
            </el-button>
          </div>
        </div> -->
        
        <!-- <div class="instructions-section">
          <h2 class="section-title">安装说明</h2>
          <div class="instructions-content">
            <el-tabs type="border-card" class="custom-tabs">
              <el-tab-pane label="iPhone安装说明" class="tab-pane">
                <div class="instruction-steps">
                  <div class="step-item">
                    <div class="step-number">1</div>
                    <div class="step-content">扫描上方二维码下载APP</div>
                  </div>
                  <div class="step-item">
                    <div class="step-number">2</div>
                    <div class="step-content">下载完成后，按照提示进行安装</div>
                  </div>
                  <div class="step-item">
                    <div class="step-number">3</div>
                    <div class="step-content">若系统提示"未受信任的企业级开发者"，请前往"设置"->"通用"->"设备管理"->"企业级应用"，信任对应的开发者</div>
                  </div>
                  <div class="step-item">
                    <div class="step-number">4</div>
                    <div class="step-content">返回桌面打开应用即可使用</div>
                  </div>
                </div>
              </el-tab-pane>
              <el-tab-pane label="Android安装说明" class="tab-pane">
                <div class="instruction-steps">
                  <div class="step-item">
                    <div class="step-number">1</div>
                    <div class="step-content">扫描上方二维码下载APP</div>
                  </div>
                  <div class="step-item">
                    <div class="step-number">2</div>
                    <div class="step-content">下载完成后，点击安装包进行安装</div>
                  </div>
                  <div class="step-item">
                    <div class="step-number">3</div>
                    <div class="step-content">若系统提示安全风险，请允许安装来自此来源的应用</div>
                  </div>
                  <div class="step-item">
                    <div class="step-number">4</div>
                    <div class="step-content">安装完成后，在桌面找到应用图标并打开</div>
                  </div>
                </div>
              </el-tab-pane>
            </el-tabs>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Download',
  methods: {
    downloadForiOS() {
      this.$message.info('iPhone版下载链接已复制到剪贴板，请在手机浏览器中打开')
      // 实际项目中这里应该是真实的下载链接
    },
    downloadForAndroid() {
      this.$message.info('Android版下载链接已复制到剪贴板，请在手机浏览器中打开')
      // 实际项目中这里应该是真实的下载链接
    }
  }
}
</script>

<style scoped>
.download-container {
  background: #f5f5f5;
  min-height: 100vh;
  padding: 30px 0;
}

.download-content {
  .content-wrapper {
    width: 1200px;
    margin: 0 auto;
    background: white;
    border-radius: 12px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
    padding: 40px;
    
    .header-section {
      text-align: center;
      margin-bottom: 40px;
      
      .page-title {
        color: #14679f;
        font-size: 36px;
        margin: 0;
        position: relative;
        padding-bottom: 20px;
        font-weight: 600;
        
        &::after {
          content: '';
          position: absolute;
          bottom: 0;
          left: 50%;
          transform: translateX(-50%);
          width: 80px;
          height: 4px;
          background: #e13834;
          border-radius: 2px;
        }
      }
    }
    
    .app-section {
      margin-bottom: 50px;
      
      .app-row {
        .app-info-col {
          .app-info {
            .app-title {
              color: #14679f;
              font-size: 32px;
              margin-bottom: 20px;
              font-weight: 600;
            }
            
            .app-description {
              color: #666;
              font-size: 18px;
              margin-bottom: 30px;
              line-height: 1.6;
            }
            
            .features-list {
              list-style: none;
              padding: 0;
              margin: 30px 0;
              
              .feature-item {
                display: flex;
                align-items: center;
                margin-bottom: 20px;
                
                &:last-child {
                  margin-bottom: 0;
                }
                
                .feature-icon {
                  color: #14679f;
                  font-size: 20px;
                  margin-right: 15px;
                  font-weight: bold;
                }
                
                .feature-text {
                  color: #333;
                  font-size: 16px;
                  line-height: 1.6;
                }
              }
            }
            
            .download-note {
              font-size: 20px;
              color: #e13834;
              font-weight: 600;
              text-align: center;
              margin: 30px 0 0;
            }
          }
        }
        
        .qr-col {
          .qr-section {
            text-align: center;
            
            .qr-code {
              display: inline-block;
              background: white;
              padding: 25px;
              border-radius: 16px;
              box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
              
              .qr-image {
                width: 220px;
                height: 220px;
                margin-bottom: 20px;
              }
              
              .qr-text {
                font-size: 20px;
                font-weight: 600;
                color: #333;
                margin: 0;
              }
            }
          }
        }
      }
    }
    
    .download-buttons-section {
      text-align: center;
      margin-bottom: 50px;
      
      .buttons-container {
        display: flex;
        justify-content: center;
        gap: 40px;
        
        .download-btn {
          padding: 0 50px;
          height: 60px;
          font-size: 18px;
          border-radius: 30px;
          display: flex;
          align-items: center;
          justify-content: center;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
          transition: all 0.3s ease;
          
          .btn-icon {
            font-size: 24px;
            margin-right: 10px;
          }
          
          .btn-text {
            font-weight: 500;
          }
          
          &.ios-btn {
            background: #14679f;
            border-color: #14679f;
            
            &:hover {
              background: #0f5280;
              border-color: #0f5280;
              transform: translateY(-2px);
              box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
            }
          }
          
          &.android-btn {
            background: #34c759;
            border-color: #34c759;
            
            &:hover {
              background: #2ab04d;
              border-color: #2ab04d;
              transform: translateY(-2px);
              box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
            }
          }
        }
      }
    }
    
    .instructions-section {
      .section-title {
        color: #14679f;
        font-size: 28px;
        margin-bottom: 30px;
        padding-bottom: 15px;
        border-bottom: 2px solid #14679f;
        font-weight: 600;
      }
      
      .instructions-content {
        .custom-tabs {
          border-radius: 8px;
          overflow: hidden;
          box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
          
          ::v-deep .el-tabs__header {
            margin: 0;
            
            .el-tabs__nav-wrap {
              &::after {
                background-color: transparent;
              }
            }
            
            .el-tabs__item {
              height: 50px;
              line-height: 50px;
              font-size: 16px;
              font-weight: 500;
              color: #666;
              
              &.is-active {
                color: #14679f;
                font-weight: 600;
              }
            }
          }
          
          ::v-deep .el-tabs__content {
            padding: 30px;
            
            .tab-pane {
              .instruction-steps {
                .step-item {
                  display: flex;
                  margin-bottom: 25px;
                  
                  &:last-child {
                    margin-bottom: 0;
                  }
                  
                  .step-number {
                    min-width: 30px;
                    height: 30px;
                    background: #14679f;
                    color: white;
                    border-radius: 50%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-weight: 600;
                    margin-right: 20px;
                    flex-shrink: 0;
                  }
                  
                  .step-content {
                    color: #333;
                    font-size: 16px;
                    line-height: 1.6;
                    padding-top: 3px;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .download-content .content-wrapper {
    width: 95%;
    margin: 0 auto;
  }
}

@media (max-width: 768px) {
  .download-container {
    padding: 20px 0;
  }
  
  .download-content .content-wrapper {
    padding: 20px 15px;
    
    .header-section .page-title {
      font-size: 28px;
    }
    
    .app-section .app-row {
      flex-direction: column;
      
      .app-info-col,
      .qr-col {
        width: 100%;
        margin-bottom: 30px;
        
        &:last-child {
          margin-bottom: 0;
        }
      }
      
      .qr-col .qr-section .qr-code {
        padding: 20px;
        
        .qr-image {
          width: 180px;
          height: 180px;
        }
      }
    }
    
    .download-buttons-section .buttons-container {
      flex-direction: column;
      gap: 20px;
      
      .download-btn {
        width: 100%;
        padding: 0;
      }
    }
    
    .instructions-section .instructions-content .custom-tabs {
      ::v-deep .el-tabs__content {
        padding: 20px 15px;
      }
    }
  }
}
</style>
